import { Box, Typography } from '@material-ui/core'

import OnScoirBadge from 'components/ScoirBadge/ScoirBadge'

import SchoolTypePill from '../components/SchoolTypePill'
import { TITLE_1_PROGRAM_OPTIONS } from '../title-one'
import DataPointsGrid, { percentFormat } from './DataPointsGrid'
import { HighschoolData } from './useGetHighschoolPreviewData'

const SchoolDetails = ({ highschool }: { highschool: HighschoolData }) => {
  if (!highschool) return null
  return (
    <Box
      display="flex"
      flexDirection="column"
      gridGap={16}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography variant="h6">School Details</Typography>
        <Box
          display="flex"
          gridGap={8}
        >
          {highschool.schoolType && <SchoolTypePill schoolType={highschool.schoolType} />}
          {highschool.isActive && <OnScoirBadge />}
        </Box>
      </Box>
      <DataPointsGrid
        dataPoints={[
          {
            title: 'CEEB Code',
            data: highschool.ceebCode,
          },
          { title: 'Religious Affiliation', data: highschool.religiousAffiliation },
          {
            title: 'Title 1 Eligibility',
            data: highschool.isTitle1Eligible ? 'Eligible' : 'Not Eligible',
          },
          {
            title: 'Title 1 Program',
            data: highschool.title1Program ? TITLE_1_PROGRAM_OPTIONS[highschool.title1Program].label : undefined,
            isPremium: true,
          },
          {
            title: '% Free and Reduced Lunch',
            data: percentFormat(highschool.pctFreeReducedLunch),
            isPremium: true,
          },
          {
            title: 'Senior Class Size',
            data: highschool.seniorClassSize,
            isPremium: true,
          },
        ]}
      />
    </Box>
  )
}

export default SchoolDetails
